import { isNativePlatform, isAndroid } from '../utils/platform';

export async function configureStatusBar(): Promise<void> {
  if (!isNativePlatform()) return;

  const { StatusBar, Style } = await import('@capacitor/status-bar');

  await StatusBar.setStyle({ style: Style.Light });
  if (isAndroid()) {
    await StatusBar.setBackgroundColor({ color: '#ffffff' });
  }
}
